const INPUT_CLASS = "border border-gray-300 h-8 rounded-sm focus:outline-none focus:border-blue-400 px-1.5 text-xs w-full";
const SELECT_CLASS = "bg-white border border-gray-300 h-8 w-full focus:outline-none focus:border-blue-400 px-1.5 rounded-sm text-xs";

const ReviewFilters = (props: any) => {
    const { filters, onFilterChange, onSearch, clearFilters, hasActiveFilters } = props

    const onKeyDown = (e: any) => {
        if (e.key === "Enter") onSearch();
    };

    return (
        <div className="mt-2.5 bg-white px-4 py-3 flex flex-wrap items-end gap-x-4 gap-y-3">
            <div className="w-[110px]">
                <label className="block text-[11px] text-gray-600 mb-1">ID</label>
                <input
                    value={filters.id}
                    onChange={(e) => onFilterChange("id", e.target.value)}
                    onKeyDown={onKeyDown}
                    type="text"
                    placeholder="Enter Id"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[180px]">
                <label className="block text-[11px] text-gray-600 mb-1">MSN</label>
                <input
                    value={filters.productMsn}
                    onChange={(e) => onFilterChange("productMsn", e.target.value)}
                    onKeyDown={onKeyDown}
                    type="text"
                    placeholder="Enter MSN"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[140px]">
                <label className="block text-[11px] text-gray-600 mb-1">User Id</label>
                <input
                    value={filters.userId}
                    onChange={(e) => onFilterChange("userId", e.target.value)}
                    onKeyDown={onKeyDown}
                    type="text"
                    placeholder="Enter User Id"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[160px]">
                <label className="block text-[11px] text-gray-600 mb-1">Review Subject</label>
                <input
                    value={filters.reviewSubject}
                    onChange={(e) => onFilterChange("reviewSubject", e.target.value)}
                    onKeyDown={onKeyDown}
                    type="text"
                    placeholder="Enter Subject"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[150px]">
                <label className="block text-[11px] text-gray-600 mb-1">From Date</label>
                <input
                    value={filters.fromDate}
                    onChange={(e) => onFilterChange("fromDate", e.target.value)}
                    type="date"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[150px]">
                <label className="block text-[11px] text-gray-600 mb-1">To Date</label>
                <input
                    value={filters.toDate}
                    onChange={(e) => onFilterChange("toDate", e.target.value)}
                    type="date"
                    className={INPUT_CLASS}
                />
            </div>
            <div className="w-[120px]">
                <label className="block text-[11px] text-gray-600 mb-1">Enabled</label>
                {/* Bound to isActive, which is what the listing requests and the
                    rows display — this used to write an `isEnabled` key that
                    nothing read. */}
                <select
                    value={filters.isActive}
                    onChange={(e) => onFilterChange("isActive", e.target.value)}
                    className={SELECT_CLASS}
                >
                    <option value=''>All</option>
                    <option value='true'>True</option>
                    <option value='false'>False</option>
                </select>
            </div>
            <div className="w-[120px]">
                <label className="block text-[11px] text-gray-600 mb-1">Approved</label>
                <select
                    value={filters.isApproved}
                    onChange={(e) => onFilterChange("isApproved", e.target.value)}
                    className={SELECT_CLASS}
                >
                    <option value=''>All</option>
                    <option value='true'>True</option>
                    <option value='false'>False</option>
                </select>
            </div>
            <button
                onClick={onSearch}
                className="h-8 px-5 rounded text-xs font-semibold bg-blue-500 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
            >
                Search
            </button>
            <button
                onClick={clearFilters}
                disabled={!hasActiveFilters}
                className="h-8 px-4 rounded text-xs font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-40 disabled:cursor-not-allowed"
            >
                Clear Filters
            </button>
        </div>
    )
}

export default ReviewFilters;
